export const FATHOM_SITE_ID = process.env.REACT_APP_FATHOM_SITE_ID || '';
export const FATHOM_SCRIPT_URL = process.env.REACT_APP_FATHOM_SCRIPT_URL || '';
export const TEST_DATA_KEY = process.env.REACT_APP_TEST_DATA_KEY || '';
